<template>
	<div class="imgPreview">
		<div>
			<img :src="imageUrl" referrerpolicy="no-referrer" @mouseover="showImg = true" @mouseout="showImg = false" :style="{ maxWidth: imgWidth + 'px', maxHeight: imgHeight + 'px' }" />
		</div>
		<div class="floating" v-show="showImg == true">
			<img :src="imageUrl" referrerpolicy="no-referrer" class="deal-img" :style="{ maxWidth: finalWidth + 'px', maxHeight: finalHeight + 'px' }" />
		</div>
	</div>
</template>

<script setup lang="ts">
	import { ref } from 'vue';
	const props = defineProps<{
		imageUrl: string;
		maxWidth?: number;
		maxHeight?: number;
		finalWidth?: number;
		finalHeight?: number;
	}>();
	const showImg = ref(false);
	const imgWidth = ref(props.maxWidth ?? 50);
	const imgHeight = ref(props.maxHeight ?? 50);
	const finalWidth = ref(props.finalWidth ?? 150);
	const finalHeight = ref(props.finalHeight ?? 150);
</script>
<style scoped>
	.floating {
		position: absolute;
	}
</style>
